const BASE_URL = "/api/v1/matchup";

export const MatchupAPI = {
  /**
   * Fetch matchup data for a specific league season and matchup ID
   * @param {string|number} fixtureId - The matchup ID (default: 1111250701)
   * @returns {Promise<Object>} - The matchup data
   */
  fetchMatchupData: async (fixtureId) => {
    const response = await fetch(`${BASE_URL}/data/${fixtureId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const data = await response.json().catch(() => null);
      const errorMessage = data?.error || `HTTP error: ${response.status}`;
      throw new Error(errorMessage);
    }

    const { status, data } = await response.json();

    if (status !== "success") {
      throw new Error("Failed to fetch matchup data");
    }

    return data;
  },
};
